/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Backup_BrowseInputs */



/**
* | output |
* | --- |
* | "Browse..." |
*
* @param {Options_Backup_BrowseInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_backup_browse = /** @type {((inputs?: Options_Backup_BrowseInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Backup_BrowseInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Parcourir...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Durchsuchen...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sfoglia...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Просматривать...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Navegar...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("浏览...")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ブラウズ...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ब्राउज़ करें...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Navegar...")
	return /** @type {LocalizedString} */ ("Browse...")
});